import '../../Components/Page/Page.css'
import SecHeader from '../../Components/SecHeader/SecHeader';
import SubSection from '../../Components/Section/SubSection';
import '../Software/Software.css';


const Competition: React.FC = () => {
    return (
        <div className="sectionContainer">
            <SecHeader title="Competition" />
            <SubSection isSplit={false}>
                <div className="description-container">
                    <b>Continuing to Use Current, Less Capable Engines​</b>
                    <p>When our technology becomes known, traditional engines will become less desirable. Revealing 
                        our R&D test data, proof of concept engines, academic papers, and Elf-Tech patents will 
                        encourage major industry players to adopt our new technology.</p>
                    <b>Other “Want-to-Be-the-Next Best Engines”​</b>
                    <p>
                       Liquid-Piston, Omega1, Achates, VC-Tech, D-Cycle, split-cycle designs, InnEngine, Alfadan, 
                       SyTech, Mazda’s new 2-stroke, Toyota’s 2-stroke, Renault’s 2-stroke, DeltaHawk’s 2-stroke, 
                       Porsche’s 6-stroke, CV-Motion, and others, tout the benefits of their design and claim to be next best engine.
                        Our E-SPEC databases incorporate “Want-to-Be Next Best Engines”​, analyze their limitations, and offer more 
                        competative solutions.
                        {/* Our E-SPEC database will analyze “Want-to-Be Next Best Engines”, and offers more 
                        competative solutions. */}
                    </p>
                    {/* <p>Other new engine designs that tout benefits include: Liquid-Piston, Omega1, Achates,
                        VC-Tech, D-Cycle, split-cycle designs, InnEngine, Alfadan, SyTech, Mazda’s new 2-
                        stroke, Toyota’s 2-stroke, Renault’s 2-stroke, DeltaHawk’s 2-stroke, Porsche’s 6-stroke,
                        CV-Motion, and others. Our E-SPEC identifies and analyzes all limitations of “want-to-
                        be-the-next engines” and defines them in our global engine designs databases.</p> */}
                    <b>EVs are “False Competition”​</b>
                    <p>It is only wishful to think that we can replace all engines with electric motors and 
                        
                        it is becoming more apparent that EVs are not as sustainable as initially thought. 
                        Elf-Tech offers lighter weight range extender options for EVs and hybrids alike.
                        In addition to more versatile and greener hybrids, new engines and fuels can and 
                        will be cleaner than 100% electric power for work.

                        {/* Other Solutions like Hybrids are more versatile and greener and new engines and fuels can and will be cleaner, 
                        better for CO2 levels than 100% electric power for work. */}
                        
                        
                        
                        {/* Even if we
                        could, all-electric power for work may not help the Earth as much as some think. The
                        best EVs will have range extenders. Hybrids are more versatile (and greener) and finally,
                        new engines and fuels can and will be cleaner (and better for CO2 levels) than 100%
                        electric power for work.</p> */}
                        </p>

                </div>
            </SubSection>
        </div >
    );
};

export default Competition;